"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const ModalContext_1 = require("../contexts/ModalContext");
const ModalPageCollapse = (props) => {
    const { inModal } = react_1.useContext(ModalContext_1.ModalContext);
    const { children, collapseInModal } = props;
    if (inModal) {
        if (collapseInModal === 'hidden') {
            return null;
        }
        if (collapseInModal === 'skipped') {
            return react_1.default.createElement(react_1.default.Fragment, null, children);
        }
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
exports.default = ModalPageCollapse;
